import { query } from '@organization/api'
import { usePaginationConfig, useQueryUpdate } from '@shared/hooks'
import { useQuery } from '@tanstack/react-query'
import { Flex } from 'antd'

import { DeleteTrustedDevices, TrustedDevicesTable } from '../components'

export const TrustedDevicesPage = () => {
  const { params, updateQuery } = useQueryUpdate()
  const { data, isLoading } = useQuery(query.mfa.getTrustedDevices(params))

  return (
    <Flex vertical gap={8}>
      {!!data?.count && (
        <Flex justify="end" gap={8}>
          <DeleteTrustedDevices />
        </Flex>
      )}

      <TrustedDevicesTable
        data={data?.results}
        loading={isLoading}
        pagination={{
          ...usePaginationConfig(data),
          onChange: (page: number, pageSize: number) =>
            updateQuery({
              ...params,
              page: page.toString(),
              page_size: pageSize.toString()
            })
        }}
      />
    </Flex>
  )
}
